import './index.less'
Vue.component("knowledge_essentials_panel", {
  props: {
    resourse_id: {
      type: String,
      required: true,
      default: ''
    },
    fragment: {
      type: Array,
      required: false,
      default: []
    },
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    showList({ list, fragment }) {
      let arr = [...list]
      if (fragment.length) {
        arr = arr.filter(item => {
          const curr = (item.inPoint || 0) / 10000000
          return fragment.find(([startTime, endTime]) => {
            return (typeof startTime == 'number' ? (curr >= startTime) : true) && (typeof endTime == 'number' ? (curr <= endTime) : true)
          })
        })
      }
      return arr
    }
  },
  watch: {
    resourse_id: {
      handler(val) {
        val && this.getData(val);
      },
      immediate: true
    }
  },
  methods: {
    init(contentId) {
      this.getData(contentId)
    },
    getData(contentId) {
      API.reqKnowledgeEssentials({ contentId }).then(res => {
        if (res.success && res.data?.length) {
          this.list = res.data
          this.$emit('if_show', true)
        } else {
          this.$emit('if_show', false)
        }
      }).catch(() => {
        this.$emit('if_show', false)
      })
    },
    handleClick(item) {
      this.$emit('seek', { currentTime: (item.inPoint || 0) / 10000000 })
    },
    durationFormat(dur) {
      dur = Math.floor(dur / 10000000 || 0); // 转秒
      var hours = Math.floor(dur / 3600); // 小时
      var minutes = Math.floor((dur % 3600) / 60); // 分
      var seconds = dur % 60; // 秒

      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      return `${hours}:${minutes}:${seconds}`;
    },
  },
  template: `
<template>
  <div class="knowledge_essentials_panel">
      <div v-for="item,i in showList" :key="item.guid_" class="knowledge_essentials_item">
        <div class="row title" @click="handleClick(item)">
          <span>{{durationFormat(item.inPoint)}}</span>
          <span>{{item.chapterTitle}}</span>
        </div>
        <div class="row" v-if="item.chapterContent">{{item.chapterContent}}</div>
        <div v-for="desc,j in item.knowledgePoints" :key="j" class="row desc">
          <span>{{durationFormat(desc.inPoint)}}</span>
          <span>{{desc.title}}</span>
        </div>
      </div>
  </div>
</template>`
});